import React from 'react';
import PropTypes from 'prop-types';
import {Typography, TextField, InputAdornment } from '@material-ui/core';

const FormTextField = ({
  input,
  label,
  meta: { touched, error },
  helperText,
  endAdornmentText,
  ...custom
}) => (
    <React.Fragment>
      <div>
        <TextField
          label={label}
          inputProps={{ 'aria-label': label }}
          error={touched && error ? true : false}
          InputProps={{ endAdornment: endAdornmentText ? <InputAdornment position="end">{endAdornmentText}</InputAdornment> : null }}
          helperText={touched && error}
          margin="dense"
          {...input}
          {...custom}
        />
      </div>
      {helperText && <Typography variant="caption">{helperText}</Typography>}
    </React.Fragment>
  );

FormTextField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  helperText: PropTypes.string,
  endAdornmentText: PropTypes.string,
};

export default FormTextField;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormTextField.js